// Módulo Vuex para el carrito de compras de NFCero
const CART_STORAGE_KEY = 'nfcero_cart'

const state = {
  items: [],
  // items structure: [{ 
  //   type: 'product', 
  //   productId: 'ring' | 'card',
  //   productName: 'Anillo NFCERO',
  //   productDetails: { size: 7, gender: 'mujer' }, // opcional
  //   quantity: 1,
  //   price: 599 
  // }, {
  //   type: 'subscription',
  //   subscriptionId: 'basic' | 'premium' | 'vip',
  //   subscriptionName: 'Premium',
  //   period: 'monthly' | 'annual',
  //   price: 249,
  //   discount: 0
  // }]
}

const getters = {
  cartItems: state => state.items,
  
  cartItemCount: state => state.items.reduce((total, item) => total + (item.quantity || 1), 0),
  
  cartSubtotal: state => state.items.reduce((total, item) => {
    let itemPrice = item.price * (item.quantity || 1)
    // Para suscripciones anuales, multiplicar por 12
    if (item.type === 'subscription' && item.period === 'annual') {
      itemPrice = itemPrice * 12
    }
    return total + itemPrice
  }, 0),

  cartDiscount: state => state.items.reduce((total, item) => {
    let itemTotal = item.price * (item.quantity || 1)
    // Para suscripciones anuales, multiplicar por 12 antes del descuento
    if (item.type === 'subscription' && item.period === 'annual') {
      itemTotal = itemTotal * 12
    }
    return total + (itemTotal * (item.discount || 0) / 100)
  }, 0),
  
  cartTotal: (state, getters) => {
    return getters.cartSubtotal - getters.cartDiscount
  },
  
  hasProduct: state => state.items.some(item => item.type === 'product'),
  
  hasSubscription: state => state.items.some(item => item.type === 'subscription'),
  
  getProductInCart: state => productId => {
    return state.items.find(item => item.type === 'product' && item.productId === productId)
  },
  
  getSubscriptionInCart: state => {
    return state.items.find(item => item.type === 'subscription')
  }
}

const mutations = {
  SET_CART_ITEMS(state, items) {
    state.items = items
  },
  
  ADD_ITEM(state, item) {
    // Para productos del mismo tipo (anillo/tarjeta), incrementar cantidad
    const existingItem = state.items.find(i => 
      i.type === item.type && 
      (item.type === 'product' ? i.productId === item.productId : i.subscriptionId === item.subscriptionId)
    )
    
    if (existingItem && item.type === 'product') {
      // Para productos, incrementar cantidad
      existingItem.quantity = (existingItem.quantity || 1) + (item.quantity || 1)
      // Actualizar detalles si vienen nuevos
      if (item.productDetails) {
        existingItem.productDetails = item.productDetails
      }
    } else if (existingItem && item.type === 'subscription') {
      // Para suscripciones, reemplazar (solo una a la vez)
      const index = state.items.indexOf(existingItem)
      state.items.splice(index, 1, { ...item })
    } else {
      state.items.push({ ...item, quantity: item.quantity || 1 })
    }
  },
  
  REMOVE_ITEM(state, { type, id }) {
    state.items = state.items.filter(item => {
      if (type === 'product') {
        return !(item.type === 'product' && item.productId === id)
      } else {
        return !(item.type === 'subscription' && item.subscriptionId === id)
      }
    })
  },
  
  UPDATE_ITEM_QUANTITY(state, { type, id, quantity }) {
    const item = state.items.find(i => {
      if (type === 'product') {
        return i.type === 'product' && i.productId === id
      } else {
        return i.type === 'subscription' && i.subscriptionId === id
      }
    })
    
    if (item) {
      item.quantity = Math.max(1, quantity)
    }
  },
  
  UPDATE_SUBSCRIPTION_PERIOD(state, { subscriptionId, period }) {
    const subscription = state.items.find(
      item => item.type === 'subscription' && item.subscriptionId === subscriptionId
    )
    
    if (subscription) {
      subscription.period = period
      // Aplicar descuento del 20% si es anual
      subscription.discount = period === 'annual' ? 20 : 0
    }
  },
  
  CLEAR_CART(state) {
    state.items = []
  }
}

const actions = {
  addToCart({ commit, state }, item) {
    // Regla de negocio: Solo una suscripción a la vez
    if (item.type === 'subscription') {
      // Remover suscripción anterior si existe
      const existingSubscription = state.items.find(i => i.type === 'subscription')
      if (existingSubscription) {
        commit('REMOVE_ITEM', { type: 'subscription', id: existingSubscription.subscriptionId })
      }
    }
    
    commit('ADD_ITEM', item)
    saveCartToLocalStorage(state.items)
  },
  
  removeFromCart({ commit, state }, { type, id }) {
    commit('REMOVE_ITEM', { type, id })
    saveCartToLocalStorage(state.items)
  },
  
  updateQuantity({ commit, state }, { type, id, quantity }) {
    commit('UPDATE_ITEM_QUANTITY', { type, id, quantity })
    saveCartToLocalStorage(state.items)
  },
  
  updateSubscriptionPeriod({ commit, state }, { subscriptionId, period }) {
    commit('UPDATE_SUBSCRIPTION_PERIOD', { subscriptionId, period })
    saveCartToLocalStorage(state.items)
  },
  
  clearCart({ commit }) {
    commit('CLEAR_CART')
    localStorage.removeItem(CART_STORAGE_KEY)
  },
  
  loadCart({ commit }) {
    const savedCart = loadCartFromLocalStorage()
    if (savedCart && savedCart.length > 0) {
      commit('SET_CART_ITEMS', savedCart)
    }
  }
}

// Helper functions
function saveCartToLocalStorage(items) {
  try {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items))
  } catch (error) {
    console.error('Error saving cart to localStorage:', error)
  }
}

function loadCartFromLocalStorage() {
  try {
    const saved = localStorage.getItem(CART_STORAGE_KEY)
    return saved ? JSON.parse(saved) : []
  } catch (error) {
    console.error('Error loading cart from localStorage:', error)
    return []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
